export class MeilisearchError extends Error {
  override name = "MeilisearchError";
}
